import { fmtSmallNumber, noExponents, secondsToHhMmSs, toK } from '@/utils'
import { isNull, isUndefined } from 'lodash'
import { ref } from 'vue'
import { useTzDate } from '../useTzDate'

export function useDexCexCellFormatter() {
  const formattingRules = ref()
  const { now } = useTzDate()

  const updateRules = () => {
    formattingRules.value = {
      'symbol.name': (v: string) => {
        if (isUndefined(v) || isNull(v)) {
          return ''
        }
        return v.split('/')[0]
      },
      pool: (v: string) => {
        if (!v) {
          return '—'
        }
        return '...' + v.slice(-10)
      },
      ex_buy: (v: string) => {
        if (v.length >= 12) {
          return v.slice(9) + '...'
        } else {
          return v
        }
      },
      ex_sell: (v: string) => {
        if (v.length >= 12) {
          return v.slice(9) + '...'
        } else {
          return v
        }
      },
      vol24h_buy: (v: number) => {
        return '$' + toK(v)
      },
      vol1h_dex: (v: number) => {
        return '$' + toK(v)
      },
      vol24h_sell: (v: number) => {
        return '$' + toK(v)
      },
      price_buy: (v: number | null) => {
        if (isNull(v) || isUndefined(v)) {
          return '—'
        }
        return fmtSmallNumber(v) ?? '—'
      },
      price_sell: (v: number | null) => {
        if (isNull(v) || isUndefined(v)) {
          return '—'
        }
        return fmtSmallNumber(v) ?? '—'
      },
      spread: (v: string) => {
        // const ret = getKeyFromCtx(v, ctx, field_name)
        return Number(v).toFixed(2) + '%'
      },
      updated_at: (v: string) => {
        if (!v) {
          return '—'
        }
        const ts = new Date(v.endsWith('Z') || v.includes('+') ? v : v + 'Z').getTime()
        const seconds = Math.floor((now.value.getTime() - ts) / 1000)
        return secondsToHhMmSs(Math.max(0, seconds))
      },
    }
  }

  return { formattingRules, updateRules }
}
